import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5 12C5 12 6.91656 13.5 10 13.5C13.0834 13.5 15 12 15 12M17.88 19C17.88 19 15.2286 17.9566 13.0834 17.1208H4.06359C2.99582 17.1208 2.13 16.2028 2.13 15.0706V3.0502C2.13 1.918 2.99582 1 4.06359 1H15.9459C17.0136 1 17.8794 1.918 17.8794 3.0502V13.4026L17.88 19Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }